import { Text, Select } from '@nike/eds';
import { useI18nContext } from 'context/language/use-i18n-context';
import ts from './i18n';
import React, { useEffect, useState } from 'react';
import { Pagination } from '../visitorpass-pagination/visitorpass-pagination';
import { Option, FilterStatusAndPage } from '../type';
import styles from '../visitor-pass.module.css';

type TsKeys = keyof typeof ts;

type Props = {
  passTypes: Option[] | undefined;
  passStatusOpts: Option[] | undefined;
  pageData: { currentPage: number; totalPages: number };
  handleFilterAndPageChange: (filterAndPage: FilterStatusAndPage) => void;
};

export const VisitorPassHeader: React.FC<Props> = ({
  passTypes,
  pageData = { currentPage: 0, totalPages: 0 },
  handleFilterAndPageChange,
}) => {
  const { i18nString } = useI18nContext();

  const [filterStatusAndPage, setFilterStatusAndPage] = useState<FilterStatusAndPage>({
    passStatus: { label: i18nString(ts.DDL_ACTIVE_PASS_TYPES), value: 0 },
    passType: { label: i18nString(ts.PASS_TYPE_GUEST), value: 10 },
    page: 1,
  } as FilterStatusAndPage);

  const passStatusOptions: Option[] = [
    { value: 0, label: i18nString(ts.DDL_ACTIVE_PASS_TYPES) },
    { value: 1, label: i18nString(ts.DDL_ALL_AVAILABLE_HISTORY) },
  ];

  useEffect(() => {
    handleFilterAndPageChange(filterStatusAndPage);
  }, [filterStatusAndPage]);

  const passStatusChange = (option: Option | undefined) => {
    setFilterStatusAndPage(
      prev => ({ ...prev, passStatus: option, page: 1 }) as FilterStatusAndPage,
    );
  };

  const passTypeChange = (option: Option | undefined) => {
    setFilterStatusAndPage(prev => ({ ...prev, passType: option, page: 1 }) as FilterStatusAndPage);
  };

  const handlePageChange = (page: number) => {
    setFilterStatusAndPage(prev => ({ ...prev, page: page }) as FilterStatusAndPage);
  };

  const getTranslation = (value: number | undefined) => {
    const key = passTypes?.find(passType => passType.value === value)?.label;
    if (key) {
      return i18nString(ts[key as TsKeys]);
    } else {
      return '';
    }
  };

  return (
    <header
      className={`eds-flex eds-flex--align-items-center eds-flex--justify-content-space-between eds-flex--wrap ${styles.pass_header}`}
    >
      <Pagination pageData={pageData} handlePageChange={handlePageChange}></Pagination>
      <Text
        as={'h2'}
        className={`${styles.h2_font} eds-text--align-center txt-align-center flex-33`}
      >
        {i18nString(ts.EMPLOYEE_ACTIVE_PAGE_NAME)}
      </Text>
      <div
        className={`${styles.eds__select} eds-flex eds-flex--align-items-flex-center eds-flex--justify-content-flex-end flex-33`}
      >
        <Select
          id="menupassType"
          label="menu Pass Type"
          options={
            passTypes?.map(passType => ({
              value: passType.value,
              label: i18nString(ts[passType.label as TsKeys]),
            })) as any
          }
          data-testid="menu-pass-type"
          value={{
            value: filterStatusAndPage?.passType?.value,
            label: getTranslation(filterStatusAndPage?.passType?.value),
          }}
          onChange={option => {
            passTypeChange(option as Option);
          }}
          name="passType"
          className={styles.select_mr}
          hideLabel={true}
          aria-label="menu Pass Type"
          aria-hidden={false}
          isSearchable={false}
        />
        <Select
          id="passstatus"
          label="pass status"
          aria-label="pass status"
          data-testid="pass-status"
          value={{
            value: filterStatusAndPage?.passStatus?.value,
            label: passStatusOptions?.find(
              ps => ps.value === filterStatusAndPage?.passStatus?.value,
            )?.label,
          }}
          options={passStatusOptions}
          onChange={option => {
            passStatusChange(option as Option);
          }}
          name="Status"
          hideLabel={true}
          isSearchable={false}
        />
      </div>
    </header>
  );
};
